import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const borderRadius = '18px';
export const disabledStyle = {
  borderRadius: borderRadius,
  backgroundColor: '#f0f0f0',
  color: '#bfbfbf'
};

export const Button1 = ({ text, onClick, disabled = false, startIcon, endIcon, sx, ...props }) => {
  const theme = useTheme();
  const buttonStyle = {
    borderRadius: borderRadius,
    backgroundColor: theme.palette.primary[400],
    color: '#ffffff',
    ...sx
  };
  //
  let cusDisabledStyle = { ...disabledStyle, ...sx };
  return (
    <Button
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      sx={disabled ? cusDisabledStyle : buttonStyle}
      {...props}
    >
      {text}
    </Button>
  );
};

export const Button2 = ({ text, onClick, disabled = false, startIcon, endIcon, sx, ...props }) => {
  const theme = useTheme();
  const buttonStyle = {
    borderRadius: borderRadius,
    backgroundColor: '#ffffff',
    color: theme.palette.primary[400],
    ...sx
  };

  let cusDisabledStyle = { ...disabledStyle, ...sx };

  return (
    <Button
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      sx={disabled ? cusDisabledStyle : buttonStyle}
      variant="outlined"
      {...props}
    >
      {text}
    </Button>
  );
};

export const Button3 = ({ text, onClick, disabled = false, startIcon, endIcon, sx, ...props }) => {
  const theme = useTheme();
  const buttonStyle = {
    borderRadius: borderRadius,
    backgroundColor: theme.palette.primary.lighter,
    color: theme.palette.primary[400],
    ...sx
  };
  let cusDisabledStyle = { ...disabledStyle, ...sx };

  return (
    <Button
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      sx={disabled ? cusDisabledStyle : buttonStyle}
      variant="outlined"
      {...props}
    >
      {text}
    </Button>
  );
};

export const Button4 = ({ text, onClick, disabled = false, startIcon, endIcon, sx, ...props }) => {
  const theme = useTheme();
  const buttonStyle = {
    borderRadius: borderRadius,
    backgroundColor: theme.palette.primary.lighter,
    color: theme.palette.primary[400],
    ...sx
  };

  let cusDisabledStyle = { ...disabledStyle, ...sx };

  return (
    <Button
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      sx={disabled ? cusDisabledStyle : buttonStyle}
      {...props}
    >
      {text}
    </Button>
  );
};
